import React, { useEffect, useState, useRef } from 'react';
import { SendIcon, ChevronDownIcon } from 'lucide-react';
import Header from '../components/Header';
const Assistant = () => {
  const [messages, setMessages] = useState([{
    id: 1,
    text: 'Hoi! Ik ben de Camping Olympia Assistent. Waarmee kan ik je helpen?',
    isBot: true
  }]);
  const [input, setInput] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const messagesEndRef = useRef(null);
  const inputRef = useRef(null);
  // Automatisch naar beneden scrollen bij nieuwe berichten
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({
      behavior: 'smooth'
    });
  }, [messages]);
  // Suggesties voor input
  useEffect(() => {
    const lowercaseInput = input.toLowerCase().trim();
    if (lowercaseInput.length > 2) {
      const matches = commonQuestions.filter(q => q.toLowerCase().includes(lowercaseInput)).slice(0, 3);
      setSuggestions(matches);
      setShowSuggestions(matches.length > 0);
    } else {
      setShowSuggestions(false);
    }
  }, [input]);
  // Voorbeeldantwoorden voor de chatbot
  const getBotResponse = question => {
    const lowerQuestion = question.toLowerCase();
    // Vuilcontainers
    if (lowerQuestion.includes('vuilnis') || lowerQuestion.includes('afval') || lowerQuestion.includes('container')) {
      return 'De vuilcontainers vind je bij het sanitairgebouw. We scheiden afval in: restafval, papier, glas en plastic. De containers zijn 24/7 toegankelijk.';
    }
    // Onweer
    else if (lowerQuestion.includes('onweer') || lowerQuestion.includes('bliksem') || lowerQuestion.includes('storm')) {
      return 'Bij onweer: blijf binnen, vermijd douchen, haal elektrische apparaten uit het stopcontact en blijf weg van het zwembad en de rivier.';
    }
    // Bar openingstijden
    else if ((lowerQuestion.includes('bar') || lowerQuestion.includes('restaurant') || lowerQuestion.includes('poolbar')) && (lowerQuestion.includes('open') || lowerQuestion.includes('tijd') || lowerQuestion.includes('uur'))) {
      return 'De bar is dagelijks geopend van 10:00 tot 23:00 uur. De keuken is open van 12:00 tot 21:00 uur. De Poolbar bij het zwembad is open van 11:00 tot 19:00.';
    }
    // Broodservice
    else if (lowerQuestion.includes('brood') || lowerQuestion.includes('broodjes') || lowerQuestion.includes('ontbijt')) {
      return 'Verse broodjes kun je bestellen bij de receptie vóór 17:00 uur voor de volgende dag. Afhalen kan vanaf 8:30 uur bij de Poolbar.';
    }
    // Zwembad
    else if (lowerQuestion.includes('zwembad') || lowerQuestion.includes('zwemmen') || lowerQuestion.includes('pool')) {
      return 'Het zwembad is geopend van 10:00 tot 19:00 uur. Kinderen onder de 10 jaar alleen onder begeleiding van een volwassene. De Poolbar is open van 11:00 tot 21:00 uur.';
    }
    // WiFi
    else if (lowerQuestion.includes('wifi') || lowerQuestion.includes('internet') || lowerQuestion.includes('verbinding')) {
      return "Gratis WiFi is beschikbaar in het hele hoofdgebouw, de Poolbar en de gameroom. Het wachtwoord is 'OlympiaCamping2023'.";
    }
    // Douches
    else if (lowerQuestion.includes('douche') || lowerQuestion.includes('sanitair') || lowerQuestion.includes('wc')) {
      return 'De sanitairgebouwen zijn 24 uur per dag geopend. Warm water is inbegrepen. Er zijn speciale familie-badkamers die je kunt reserveren bij de receptie.';
    }
    // Activiteiten voor kinderen
    else if ((lowerQuestion.includes('kind') || lowerQuestion.includes('kids')) && (lowerQuestion.includes('activiteit') || lowerQuestion.includes('doen'))) {
      return 'Voor kinderen hebben we dagelijks activiteiten: knutselen (10:00), zwembadspellen (14:00), en mini-disco (19:00). Zie de activiteitenkalender in de app voor het volledige programma.';
    }
    // Fiets huren
    else if ((lowerQuestion.includes('fiets') || lowerQuestion.includes('mountainbike')) && (lowerQuestion.includes('huur') || lowerQuestion.includes('huren') || lowerQuestion.includes('leen'))) {
      return 'Je kunt fietsen en mountainbikes huren bij de receptie. Prijs: €15 per dag voor een gewone fiets, €25 voor een mountainbike. Reserveer via deze app of bij de receptie.';
    }
    // Receptie openingstijden
    else if ((lowerQuestion.includes('receptie') || lowerQuestion.includes('balie')) && (lowerQuestion.includes('open') || lowerQuestion.includes('tijd') || lowerQuestion.includes('uur'))) {
      return 'De receptie is geopend van 8:00 tot 20:00 uur op weekdagen, van 8:00 tot 22:00 op zaterdag en van 9:00 tot 19:00 op zondag.';
    }
    // Noodgeval
    else if (lowerQuestion.includes('nood') || lowerQuestion.includes('spoed') || lowerQuestion.includes('hulp')) {
      return 'Bij noodgevallen: bel 112 voor levensbedreigende situaties. Voor campinggerelateerde noodgevallen buiten receptie-uren, bel de noodnummer: +32 (0)80 123 456.';
    }
    // Standaard antwoord
    else {
      return 'Dat weet ik niet precies. Je kunt het beste even langsgaan bij de receptie, zij helpen je graag verder! Of probeer een andere vraag te stellen.';
    }
  };
  const handleSend = () => {
    if (input.trim() === '') return;
    // Voeg gebruikersbericht toe
    const userMessage = {
      id: messages.length + 1,
      text: input,
      isBot: false
    };
    setMessages(prev => [...prev, userMessage]);
    setInput('');
    setShowSuggestions(false);
    // Simuleer een korte vertraging voordat de bot antwoordt
    setTimeout(() => {
      const botResponse = {
        id: messages.length + 2,
        text: getBotResponse(input),
        isBot: true
      };
      setMessages(prev => [...prev, botResponse]);
    }, 1000);
  };
  const handleSelectSuggestion = suggestion => {
    setInput(suggestion);
    setShowSuggestions(false);
    inputRef.current?.focus();
  };
  return <div className="flex flex-col h-full bg-gray-50" data-id="element-129">
      <Header title="Camping Assistent" showBackButton data-id="element-130" />
      <div className="flex-1 p-4 overflow-y-auto" data-id="element-131">
        <div className="space-y-4" data-id="element-132">
          {messages.map(message => <div key={message.id} className={`flex ${message.isBot ? 'justify-start' : 'justify-end'}`} data-id="element-133">
              <div className={`max-w-[85%] rounded-lg p-3 ${message.isBot ? 'bg-white text-black shadow-sm' : 'bg-[#f9b30f] text-black'}`} data-id="element-134">
                <p className="text-sm" data-id="element-135">{message.text}</p>
              </div>
            </div>)}
          <div ref={messagesEndRef} data-id="element-136" />
        </div>
      </div>
      <div className="p-4 bg-white border-t" data-id="element-137">
        <div className="relative" data-id="element-138">
          <div className="flex items-center" data-id="element-139">
            <input type="text" value={input} onChange={e => setInput(e.target.value)} onKeyPress={e => e.key === 'Enter' && handleSend()} ref={inputRef} placeholder="Stel een vraag..." className="flex-1 bg-gray-100 rounded-l-lg py-3 px-4 focus:outline-none" data-id="element-140" />
            <button onClick={handleSend} className="bg-[#f9b30f] text-black p-3 rounded-r-lg" data-id="element-141">
              <SendIcon size={20} data-id="element-142" />
            </button>
          </div>
          {showSuggestions && <div className="absolute bottom-full left-0 right-0 mb-1 bg-white rounded-lg shadow-lg border border-gray-200 overflow-hidden z-10" data-id="element-143">
              {suggestions.map((suggestion, index) => <button key={index} onClick={() => handleSelectSuggestion(suggestion)} className="w-full text-left p-3 hover:bg-gray-50 border-b border-gray-100 last:border-0" data-id="element-144">
                  {suggestion}
                </button>)}
            </div>}
        </div>
        <div className="mt-3" data-id="element-145">
          <div className="flex items-center justify-between mb-2" data-id="element-146">
            <p className="text-xs text-gray-500" data-id="element-147">Veelgestelde vragen:</p>
            <button className="text-xs text-[#f9b30f] flex items-center" onClick={() => setShowSuggestions(!showSuggestions)} data-id="element-148">
              Meer suggesties
              <ChevronDownIcon size={14} className={`ml-1 transform ${showSuggestions ? 'rotate-180' : ''}`} data-id="element-149" />
            </button>
          </div>
          <div className="flex flex-wrap gap-2" data-id="element-150">
            <QuickQuestion question="Hoe laat opent het zwembad?" onClick={() => {
            setInput('Hoe laat opent het zwembad?');
            setTimeout(handleSend, 100);
          }} data-id="element-151" />
            <QuickQuestion question="Waar gooi ik mijn vuilnis?" onClick={() => {
            setInput('Waar gooi ik mijn vuilnis?');
            setTimeout(handleSend, 100);
          }} data-id="element-152" />
            <QuickQuestion question="Wat moet ik doen bij onweer?" onClick={() => {
            setInput('Wat moet ik doen bij onweer?');
            setTimeout(handleSend, 100);
          }} data-id="element-153" />
            <QuickQuestion question="Is er broodservice?" onClick={() => {
            setInput('Is er broodservice?');
            setTimeout(handleSend, 100);
          }} data-id="element-154" />
          </div>
        </div>
      </div>
    </div>;
};
const QuickQuestion = ({
  question,
  onClick
}) => {
  return <button className="bg-gray-100 text-gray-700 text-xs py-1.5 px-3 rounded-full hover:bg-gray-200" onClick={onClick} data-id="element-155">
      {question}
    </button>;
};
// Lijst met veelgestelde vragen voor suggesties
const commonQuestions = ['Hoe laat opent het zwembad?', 'Waar gooi ik mijn vuilnis?', 'Wat moet ik doen bij onweer?', 'Hoe laat gaat de bar open?', 'Is er broodservice?', 'Wat is het WiFi wachtwoord?', 'Zijn er activiteiten voor kinderen?', 'Kan ik een fiets huren?', 'Wat zijn de openingstijden van de receptie?', 'Wat te doen bij een noodgeval?', 'Hoe laat moet ik uitchecken?', 'Zijn de douches 24 uur open?', 'Waar kan ik eten bestellen?', 'Is er een wasmachine beschikbaar?', 'Hoe werkt de BBQ reservering?', 'Wat kost een mountainbike huren?', 'Zijn huisdieren toegestaan?', 'Hoe laat start de kinderdisco?', 'Waar kan ik mijn auto parkeren?', 'Is er een supermarkt in de buurt?'];
export default Assistant;